import classNames from 'classnames'
import { Text } from '../Text'
import { useTabsContext } from './Tabs'
import type { TabProps } from './types'
import { Transition } from '../Transition'

const TabBorder = ({ isActive }: { isActive: boolean }) => {
  return (
    <Transition.Fade show={isActive}>
      <div
        className={classNames(
          'absolute inset-x-0 bottom-0',
          isActive ? 'h-[2px] bg-[#3D3D3D]' : 'h-[1px] bg-[#E7E7E7]',
        )}
      />
    </Transition.Fade>
  )
}

export const Tab: React.FC<React.PropsWithChildren<TabProps>> = ({
  index,
  children,
}) => {
  const { setActiveTab, activeTab, id } = useTabsContext()

  const handleClick = () => {
    setActiveTab(index)
  }

  const isActive = activeTab === index
  const baseId = `${id}-tab[${index}]`

  return (
    <button
      aria-controls={`${baseId}-panel`}
      aria-selected={isActive}
      id={`${baseId}-button`}
      className={classNames('py-4 relative w-full')}
      onClick={handleClick}
      role="tab"
    >
      <Text variant={isActive ? 'title-six' : 'body-md'}>{children}</Text>
      <TabBorder isActive={isActive} />
    </button>
  )
}
